import {Component, Input} from "@angular/core";

@Component({
    template: ""
})
export abstract class TipoPreguntaComponent {
    @Input() public accesoPublico = false;
}
